import React, { ReactElement } from 'react';

const BrazilCurrencyIcon = (): ReactElement => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.66667" fill="black" />
    <text
      x="8"
      y="11"
      fontFamily="Arial, sans-serif"
      fontSize="7"
      fontWeight="bold"
      fill="white"
      textAnchor="middle"
    >
      R$
    </text>
  </svg>
);

export default BrazilCurrencyIcon;
